import Axios from "axios";
import AuthService from "./Auth";

const API_SERVER =
  process.env.NODE_ENV === "production"
    ? "https://www.clon.cloud"
    : "http://localhost:8090";

const CLI_SERVER =
  process.env.NODE_ENV === "production"
    ? "https://www.clon.cloud"
    : "http://localhost:8080";

const ACCOUNT_RECEIVABLE_MOVEMENTS_DEFAULT_DAYS = 10;

export default class DataRoot {
  appName = "web";
  errors = null;
  isBusy = false;
  isBroken = false;

  /* Generar objeto auth, pasar como referencia instancia de DataRoot */
  constructor(eventHub, moment) {
    this.eventHub = eventHub;
    this.moment = moment;
    this.setError = this.setError.bind(this);
    this.createConnections = this.createConnections.bind(this);
    this.search = this.search.bind(this);
    this.add = this.add.bind(this);
    this.save = this.save.bind(this);
    this.patch = this.patch.bind(this);
    this.delete = this.delete.bind(this);
    this.getObjectByURL = this.getObjectByURL.bind(this);
    this.getUserParam = this.getUserParam.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.setDrawer = this.setDrawer.bind(this);
    this.auth = new AuthService(this);
    this.API_SERVER = API_SERVER;
    this.CLI_SERVER = CLI_SERVER;
    this.ACCOUNT_RECEIVABLE_MOVEMENTS_DEFAULT_DAYS = ACCOUNT_RECEIVABLE_MOVEMENTS_DEFAULT_DAYS;
    this.disableAlerts = false;
    this.drawer = false;
    this.createConnections();
  }

  async setError(error, reload) {
    let errmsg = null;
    if (error.isAxiosError) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status === 500) {
            errmsg = "Error interno del servidor";
          } else if (error.response.status === 404) {
            errmsg = "Registro no encontrado";
          }
        } else {
          errmsg = "Error de conexión";
        }
        if (error.response.data) {
          const responseMessage = this.responseDataToString(
            error.response.data
          );
          if (responseMessage) {
            errmsg = (errmsg ? errmsg + ": " : "") + responseMessage; //eslint-disable-line
          }
        }
        if (!errmsg) {
          errmsg = error.response.status + " - " + error.response.statusText;
        }
      }
      if (!errmsg) {
        errmsg = "Error de conexión";
      }
    }
    if (!errmsg) {
      errmsg = error.message ? error.message : error;
    }
    this.errors = errmsg;
    if (!this.disableAlerts) {
      await this.eventHub.$emit("error", errmsg, reload);
    }
  }

  toggleDrawer() {
    this.drawer = !this.drawer;
    this.eventHub.$emit("drawerChanged");
  }

  setDrawer(val) {
    if (this.drawer !== val) {
      this.drawer = val;
      this.eventHub.$emit("drawerChanged");
    }
  }

  responseDataToString(objeto) {
    if (typeof objeto === "string") {
      const trimmed = objeto.trim();
      if (/^<!doctype html/i.test(trimmed) || /^<html/i.test(trimmed)) {
        return null;
      }
      return trimmed;
    }

    let result = [];
    let key = "";
    let key2 = "";
    for (key of Object.keys(objeto)) {
      if (Array.isArray(objeto[key])) {
        objeto[key].forEach(e => {
          if (typeof e === "string") {
            result.push(e);
          } else {
            for (key2 of Object.keys(e)) {
              if (Array.isArray(e[key2])) {
                e[key2].forEach(ie => {
                  result.push(ie);
                });
              } else {
                result.push(e[key2]);
              }
            }
          }
        });
      } else {
        result.push(objeto[key]);
      }
    }
    return result.join("\n");
  }

  createConnections() {
    delete this.axios;

    this.axios = new Axios.create({
      baseURL: API_SERVER,
      timeout: 20000,
      crossdomain: true,
      withCredentials: true,
      xsrfCookieName: "csrftoken",
      xsrfHeaderName: "X-CSRFTOKEN"
    });

    this.axios.interceptors.request.use(
      config => {
        this.errors = null;
        this.isBusy = true;
        return config;
      },
      error => {
        this.isBusy = false;
        this.isBroken = true;
        this.setError(error);
        Promise.reject(error);
      }
    );

    this.axios.interceptors.response.use(
      response => {
        this.isBusy = false;
        this.isBroken = false;
        this.errors = null;
        return response;
      },
      async error => {
        if (error.response.status === null) {
          //can't find API
          this.isBroken = true;
        }
        if (error.response.status === 401) {
          //Session Expired
          this.isBusy = false;
          this.setError("Sesión expirada", true);
          return Promise.reject("Sesión expirada");
        } else {
          this.isBusy = false;
          this.setError(error);
          return Promise.reject(error);
        }
      }
    );
  }

  async search(endpoint, searchstring, ordering, filterstring, page, pageSize) {
    try {
      return await this.axios.get(
        // eslint-disable-next-line
        encodeURI(endpoint + "/" +
            // eslint-disable-next-line
        (searchstring ? "?search=" + searchstring : "") +
            // eslint-disable-next-line
        (filterstring ? (searchstring ? "&" : "?") + filterstring : "") +
            // eslint-disable-next-line
        (ordering ? (searchstring || filterstring ? "&" : "?") + "ordering=" + ordering : "") +
            // eslint-disable-next-line
        (page ? (searchstring || filterstring || ordering ? "&" : "?") + "page=" + page.toString() : "") +
            // eslint-disable-next-line
        (pageSize ? (searchstring || filterstring || ordering || page ? "&" : "?") + "page_size=" + pageSize.toString() : "")
        )
      );
    } catch (error) {
      return null;
    }
  }

  async searchAll(endpoint, searchstring, ordering, filterstring) {
    let all = [];
    let response = null;
    // eslint-disable-next-line
    response = await this.search (endpoint, searchstring, ordering, filterstring)
    Array.prototype.push.apply(all, response.data.results);
    while (response.data.next !== null) {
      response = await this.axios.get(response.data.next);
      Array.prototype.push.apply(all, response.data.results);
    }
    return all;
  }

  add(endpoint, existsstring, object, configs) {
    return Promise.resolve()
      .then(() => {
        //verificar que el objeto no exista
        if (existsstring) {
          return this.axios
            .get(endpoint + "/?" + existsstring)
            .then(response => {
              if (response.data.results.length > 0) {
                this.setError("El registro ya existe");
                return response;
              } else {
                return null;
              }
            });
        } else {
          return null;
        }
      })
      .then(response => {
        if (response) {
          return response;
        } else {
          //Si no existe hacer el alta
          return this.axios.post(endpoint + "/", object, configs);
        }
      })
      .then(response => {
        let data = response.data.results
          ? response.data.results
          : response.data;
        return Array.isArray(data) ? data[0] : data;
      })
      .catch(() => {
        return null;
      });
  }

  save(object, configs, object_url) {
    return this.axios
      .put((object_url ? object_url : object.url), object, configs) //eslint-disable-line
      .then(response => {
        return Array.isArray(response.data) ? response.data[0] : response.data;
      })
      .catch(() => {
        return null;
      });
  }

  patch(object, configs, object_url) {
    return this.axios
      .patch((object_url ? object_url : object.url), object, configs) //eslint-disable-line
      .then(response => {
        return Array.isArray(response.data) ? response.data[0] : response.data;
      })
      .catch(() => {
        return null;
      });
  }

  delete(object_url) {
    return this.axios
      .delete(object_url)
      .then(response => {
        return Array.isArray(response.data) ? response.data[0] : response.data;
      })
      .catch(() => {
        return null;
      });
  }

  getObjectByURL(args) {
    return this.axios
      .get(args)
      .then(response => {
        return Array.isArray(response.data) ? response.data[0] : response.data;
      })
      .catch(() => {
        return null;
      });
  }

  /* If not defVal returns true or false, if defVal return obj[atr] or defVal */
  isNullOrEmpty(obj, atr, defVal) {
    let hasDefVal = (!(defVal === undefined)) //eslint-disable-line
    /* absence of property | 0 | "0" | "" | null | undefined | NaN | false => are evaluated as NullOrEmpty */
    /*eslint-disable-next-line */
    if (!obj[atr] || obj[atr].toString().replace(/\.0+$/, "") === "0") {
      return hasDefVal ? defVal : true;
    } else {
      return hasDefVal ? obj[atr] : false;
    }
  }

  getUserParam(paramName) {
    let index = this.appInfo.configuration.findIndex(
      item => item.name === paramName
    );
    let response = null;
    if (index !== -1) {
      response = this.appInfo.configuration[index].value;
    }
    switch (paramName) {
      case "defaultTerritory":
        response = response ? response : null;
        break;
      case "defaultCropId":
        response = response ? parseInt(response) : 0;
        break;
      case "disableIntellySearch":
        response = response ? response === "true" : false;
        break;
    }
    return response;
  }
}
